export const mainLayoutTokens = {
  childrenGap: 15,
  padding: 30,
};

export const stepLayoutTokens = {
  childrenGap: 15,
  padding: '32px',
  maxWidth: '67%',
};

export const selectCampaignsStepLayoutTokens = {
  childrenGap: 15,
  padding: '32px',
};

export const footerStyles = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
};

export const cardHeaderStyles = {
  cardHeader: {
    display: 'flex',
  },
  label: {
    paddingRight: '5px',
  },
};

export const selectCampaignsStyles = {
  root: {
    display: 'flex',
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
  },
};

export const selectedCampaignsAccordionStyles = {
  accordionHeader: {
    display: 'flex',
    paddingBottom: '5px',
    '& button': {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
  },
  accordionHeaderText: {
    marginRight: 'auto',
  },
  count: {
    color: '#616161',
  },
  tagsList: {
    columnGap: '2px',
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: '2px',
  },
};

export const studySummaryDrawerStyles = {
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  drawer: {
    paddingLeft: '15px',
    paddingRight: '20px',
    backgroundColor: '#f5f5f5',
    backgroundSize: '100% 0px',
    borderLeftStyle: 'solid',
    borderLeftWidth: '1px',
    borderLeftColor: '#e1dfdd',
  },
  drawerHeader: {
    paddingBottom: '20px',
  },
  subTitle: {
    marginTop: '20px !important',
    paddingBottom: '15px',
  },
  totalBudget: {
    paddingBottom: '10px',
    color: '#616161',
  },
};

